import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        rooms: '=',
        roomForm: '=',
        timeCopy: '=',
        isNewRoom: '=',
        cancelNewRoom: '&',
        disableEditing: '='
    },
    template: `
        <form class="form" ng-submit="vm.save()">
            <form-wrapper form="vm.form">
                <form-row error="vm.timeCopy.errors.roomId" ng-if="!vm.isNewRoom">
                    <label class="label">{{ 'occurrence.Room' | translate }}</label>
                    <div class="items">
                        <select
                            ng-disabled="vm.disableEditing"
                            ng-readonly="vm.disableEditing"
                            class="form-control"
                            ng-model="vm.timeCopy.roomId"
                            ng-options="room.id as room.name for room in vm.rooms">
                            <option value=""></option>
                        </select>
                        <form-row-error></form-row-error>
                        <a ng-if="!vm.disableEditing" class="btn discrete small" ng-click="vm.isNewRoom = true">{{ 'occurrence.Add new room' | translate }}</a>
                    </div>
                </form-row>
                <div ng-if="vm.isNewRoom">
                    <form-row error="vm.roomForm.errors.name">
                        <label class="label">{{ 'occurrence.Room' | translate }}</label>
                        <div class="items">
                            <input type="text" class="form-control" ng-model="vm.roomForm.model.name" placeholder="{{ 'room.Name' | translate }}">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.roomForm.errors.capacity">
                        <label class="label"></label>
                        <div class="items">
                            <input type="number" class="form-control small" ng-model="vm.roomForm.model.capacity" placeholder="{{ 'room.Capacity' | translate }}">
                            <a class="btn discrete small" ng-click="vm.cancelNewRoom()">{{ 'general.Back' | translate }}</a>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
            </form-wrapper>
            <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
        </form>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/manageTrainingTime/room/index.js